import { render, staticRenderFns } from "./Foldable.vue?vue&type=template&id=6335e6db&"
import script from "./Foldable.vue?vue&type=script&lang=ts&"
export * from "./Foldable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports